import client from '/src/services/client.js';

export default {
    refreshInfoUser : () => client.get('user/info'),
    getUser : (id) => client.get(`company/user/${id}`),
    getUsers : (data) => client.get(`company/users`, data),
    addUser : (id, data) => client.post(`company/users/${id}`, data),
    updateUser : (id, data) => client.put(`company/users/${id}`, data),
    deleteUser : (id) => client.delete(`company/users/${id}`)
}